import { IBaseResponseData, IBill } from '../index.js'

/**
 * This interface defines the object that is returned by the Congress API when
 * you request a list of bills from the `/bill` endpoint.
 */
export interface IBillsResponse extends IBaseResponseData {
  bills: IBill[]
}
